export const theme = {
  global: {
    font: {
      family: 'Roboto, Open Sans',
      size: '18px',
      height: '20px',
    },
    colors: {
      background: '#ffffff',
    },
  },
  meter: {
    extend: {
      display: 'flex',
    } as any,
  },
  formField: {
    label: {
      requiredIndicator: true,
    },
  },
};
